export const REDUX_SET = '/redux/container/UserSwitch/set';
